export default "__VITE_ASSET__BdQNjEwP__"